import {AutoEletric} from './auto-eletric';
import {AutoEletricProvidedService} from './auto-eletric-provided-service';
import { Vehicle } from './vehicle';

export class Technician {
  constructor(public id?: number,
              public name?: string,
              public rg?: string,
              public cpf?: string,
              public phone?: string,
              public deaccredited?: boolean,
              public autoEletric?: AutoEletric,
              public autoEletricServices?: Array<AutoEletricProvidedService>,
              public vehicle?: Vehicle,
              public scores?,
              public score?,
              public argosUser?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/technician.ts